import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { newModalConfiguration } from 'app/shared/dynamic/models/modal-configuration.model';
import { DynamicLoaderService } from 'app/shared/dynamic/services/dynamic-loader.service';
import { Subject, Subscription } from 'rxjs';
import { ViewTermsAndConditionsModalComponent } from '../view-terms-and-conditions-modal/view-terms-and-conditions-modal.component';

@Component({
  selector: 'core-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TermsAndConditionsModalComponent implements OnDestroy {
  @Input()
  base64!: string;

  @Output()
  signOutClick = new EventEmitter<void>();

  @Output()
  acceptClick = new EventEmitter<void>();

  isDirty = false;
  language = this.translateService.currentLang;
  private subscription: Subscription = new Subscription();

  private destroyed = new Subject<void>();

  constructor(
    private translateService: TranslateService,
    private dynamicLoaderService: DynamicLoaderService
  ) {}

  ngOnDestroy(): void {
    this.destroyed.next();
  }

  onAcceptClick(): void {
    this.acceptClick.emit();
  }

  onSignOutClick(): void {
    this.signOutClick.emit();
  }

  onViewClick(): void {
    const config = newModalConfiguration({
      panelClass: 'popup full',
      animation: 'fromRight',
      outsideClick: false,
    });
    const data = {
      base64: `data:application/pdf;base64,${this.base64}`,
    };
    this.dynamicLoaderService
      .open<ViewTermsAndConditionsModalComponent>(
        ViewTermsAndConditionsModalComponent,
        config,
        data
      )
      .then(container => {
        const termsModalComponent = (
          container.componentRef as ComponentRef<ViewTermsAndConditionsModalComponent>
        ).instance;
        this.subscription.add(
          termsModalComponent.closeClick.subscribe(() => {
            container.close();
          })
        );
      });
  }
}
